module.exports = __webpack_public_path__ + "media/images/admin/icons/external-link-90577cce48ecfddde9064420d52d9f5f.svg";